<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar> 
          <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
          </ion-buttons>
          <ion-title>PENDIENTES</ion-title>
        </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-refresher slot="fixed" @ionRefresh="recargaEventosSinFinalizar($event);" >
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
    
    <div class="my-3">
      <div v-if="eventosPersona.length == 0" class="text-center d-block">
        <p>
          Usted no tiene eventos pendientes.
        </p>
      </div>

      <ion-card class="cursor-pointer" @click="muestraModalVerEvento(evento)" :key="index" v-for="(evento, index) in eventosPersona" :color="evento.estado_actual.hev_estado == 1 ? 'danger': evento.estado_actual.hev_estado == 2 ? 'warning':'primary'">
        <!-- <ion-card-header>
          <ion-card-subtitle class="text-dark" >
            <div class="row">
              <div class="col">
                <fa v-if="evento.estado_actual.hev_estado == 1" :icon="['fas', 'exclamation-circle']" class="text-dark mr-2" />
                <fa v-if="evento.estado_actual.hev_estado == 2" :icon="['fas', 'clock']" class="text-dark mr-2" />
                <fa v-if="evento.estado_actual.hev_estado == 3" :icon="['fas', 'check-circle']" class="text-dark mr-2" />
                <span v-text="evento.fecha_ff"></span>
              </div>
            </div>
          </ion-card-subtitle>
          <ion-card-title v-text="evento.tev_tipo"></ion-card-title>
        </ion-card-header> -->
        <div class="container-fluid p-3">
          <div class="row" style="font-size:small;">
            <div class="col">Ticket {{ evento.evt_id }}</div>
            <div class="col text-right">
              <ion-label>
                {{  
                  evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[2] + '/' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[1] + '/' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[0] + ' ' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[1].split(':')[0] + ':' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[1].split(':')[1]
                }}
              </ion-label>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <h5 class="ion-text-start ion-no-padding ion-no-margin">
                <fa v-if="evento.estado_actual.hev_estado == 1" :icon="['fad', 'exclamation-circle']"  ></fa>
                <fa v-if="evento.estado_actual.hev_estado == 2" :icon="['fad', 'clock']"></fa>
                <fa v-if="evento.estado_actual.hev_estado == 3" :icon="['fad', 'check-circle']"  ></fa>
                {{evento.tev_tipo}}
              </h5>
            </div>
            <div class="col text-right font-weight-bold pt-2">
              <ion-label><span>{{evento.estado_actual.tpe_estado}}</span></ion-label>
            </div>
          </div>
          <!-- <div class="row mt-2">
            <div class="col"> </div>
           
          </div> -->
        </div>
      </ion-card>
    </div>
    <ion-fab @click="muestraModalNuevoEvento()" vertical="bottom" horizontal="end" slot="fixed">
      
      <ion-button color="secondary" shape="round" class="px-0">
        <ion-icon :icon="add" class="mr-1"></ion-icon>
        NUEVO EVENTO
      </ion-button>
    </ion-fab>

    </ion-content>
  </ion-page>
</template>

<script>
import { IonContent, IonFab, IonRefresher, IonRefresherContent, isPlatform, IonIcon, IonButtons, IonMenuButton,  IonCard,   
         IonHeader, IonPage,  IonTitle, IonToolbar, modalController, loadingController, toastController, IonButton} from '@ionic/vue';

import NuevoEvento          from './NuevoEvento.vue'
import VerEvento            from './VerEvento.vue';
import { add              } from 'ionicons/icons';
import { defineComponent  } from 'vue';
import { Preferences      } from '@capacitor/preferences';
import { cerrarSesion     } from '@/plugins/funciones.ts';
import { App              } from '@capacitor/app';
import axios                from 'axios';
import rutaBase             from '@/plugins/variables';

export default defineComponent({
  name: 'Pendientes',
  components: {
    IonContent,
    IonHeader,
    IonButtons,
    IonMenuButton,
    IonPage,
    IonCard,
    IonFab,
    IonIcon,
    IonTitle,
    IonToolbar,
    IonRefresher, 
    IonRefresherContent,
    IonButton
  },

  data(){
    return {
      add, 
      modalNuevoEvento: null,
      modalVerEvento  : null,
      eventosPersona  : [],
      cargandoTodo    : null,
      esMovil         : false,
      plataformas     : null
    }
  },
  mounted(){
    this.detectaPlataforma();
    this.listarEventosSinFinalizar();
    this.intervaloPend = setInterval(this.recargaEventosSinFinalizar, 15000);
  },
  unmounted() {
    clearInterval(this.intervaloPend);    
  },
  methods:{
    detectaPlataforma(){
      if((isPlatform('ios') || isPlatform('android') || isPlatform('mobile')) || !isPlatform('mobileweb') && !isPlatform('desktop')){
        this.esMovil = true;
        // Si la app vuelve a primer plano, reactivar el intervalo de recarga.
        App.addListener('appStateChange', async (state) => {
          if (state.isActive){
            this.intervaloPend = setInterval(this.recargaEventosSinFinalizar, 15000);
            this.recargaEventosSinFinalizar();
          }
          else{
            clearInterval(this.intervaloPend); 
          }
        });
      }
      else{
        this.esMovil = false;
      } 
    },

    async cargandoDatosTotal() {
      this.cargandoTodo = await loadingController
        .create({
          cssClass: 'text-secondary',
          message: 'CARGANDO DATOS...',
          animated:false,
          mode:'md'
        });

      await this.cargandoTodo.present();
    },

    async muestraModalNuevoEvento(){
      this.modalNuevoEvento = await modalController
        .create({
          component: NuevoEvento,
          componentProps  : {
            esMovil       : this.esMovil
          },
          backdropDismiss: false
        });
      this.modalNuevoEvento.present();
      const modalResponse = await this.modalNuevoEvento.onDidDismiss();
      modalResponse.data && this.modalCloseHandlerNE({...modalResponse.data})
    },

    async listarEventosSinFinalizar(){
      await this.cargandoDatosTotal();
      const rutPersona  = await Preferences.get({ key: 'rut' });
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data  = new URLSearchParams();
      this.eventosPersona = [];
      data.append('rut_persona', parseInt(rutPersona.value));
      axios.post(rutaBase+'/normal/listarEventosSinFinalizar', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.eventosPersona = resp.data;
          this.cargandoTodo.dismiss();
        }
      }).catch(() =>{
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async recargaEventosSinFinalizar(evento=false){
      const rutPersona  = await Preferences.get({ key: 'rut' });
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data  = new URLSearchParams();
      data.append('rut_persona', parseInt(rutPersona.value));
      axios.post(rutaBase+'/normal/listarEventosSinFinalizar', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.eventosPersona = resp.data;
          if(evento){ evento.target.complete(); }
        }
      }).catch(() =>{
        this.eventosPersona = [];
        if(evento){ evento.target.complete(); }
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    },

    async muestraModalVerEvento(evento){
      this.modalVerEvento = await modalController
        .create({
          component       : VerEvento,
          //backdropDismiss : false,
          componentProps  : {
            propEvento    : evento,
            //modal         : this.modalVerEvento,
            esMovil       : this.esMovil
          }
        });
      this.modalVerEvento.present();
      const modalResponse = await this.modalVerEvento.onDidDismiss();
      modalResponse.data && this.modalCloseHandlerVE({...modalResponse.data})
    },

    async modalCloseHandlerNE(_value) {
      const datos = _value;
      if(datos.respuesta != null){
        if(datos.respuesta == 1){
          //await this.cargandoDatosTotal();
          this.listarEventosSinFinalizar();
          this.muestraToast('EVENTO REPORTADO EXITOSAMENTE.');
        }
        else if(datos.respuesta == 2){
            this.muestraToast('ERROR AL REGISTRAR LOS DATOS.');
        }
        else if(datos.respuesta == 3){
          this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
        }
      }
    },

    modalCloseHandlerVE(_value) {
      const datos = _value;
      if(datos.respuesta != null){
        if(datos.respuesta == 1){
          //this.cargandoDatosTotal();
          this.listarEventosSinFinalizar();
          this.muestraToast(datos.msj);
        }
        else if(datos.respuesta == 2){
            this.muestraToast('ERROR AL REGISTRAR LOS DATOS.');
        }
        else if(datos.respuesta == 3){
          this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
        }
      }
    },
  }
});
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  
  color: #8c8c8c;
  
  margin: 0;
}

#container a {
  text-decoration: none;
}

.orange{
  background:#ffa500 !important;
  color:white !important
}
.cursor-pointer{
  cursor:pointer !important; 
}
</style>